// Window events for the header search (pages/ui/HubSearch.tsx).

/** Opens the search from anywhere (header buttons, phone menu). */
export const OPEN_HUB_SEARCH = 'hub:open-search'
/** A product or recipe was saved from the search, so open product lists refresh. */
export const PRODUCTS_CHANGED = 'hub:products-changed'
/** An ingredient was saved from the search, so the ingredients list refreshes. */
export const INGREDIENTS_CHANGED = 'hub:ingredients-changed'

export function openHubSearch() {
  window.dispatchEvent(new Event(OPEN_HUB_SEARCH))
}
